import PadraoModel from 'src/core/model/PadraoModel.js'

export default class OlxCambioModel extends PadraoModel {
  recurso = 'olx/cambios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Câmbios Olx';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
